import { ScreeningTabs } from "shared/components/ScreeningTabs";

export const ScreeningTemplatesHeader = () => {
  return (
    <>
      <h1 className="pb-6 text-xl font-bold text-content-1000 border-b border-alpha-40 pl-6 mb-3">
        Screening settings
      </h1>

      <div className="ml-6">
        <ScreeningTabs />
      </div>
    </>
  );
};
